import script from "./CreatePropertyButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreatePropertyButton.vue?vue&type=script&setup=true&lang=ts"

import "./CreatePropertyButton.vue?vue&type=style&index=0&id=3419a4d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3419a4d4"]])

export default __exports__